import { acquireBackendToken } from "./acquireBackendToken";
import { apiUrl } from "./apiUrl";

type QueryValue = string | number | boolean | null | undefined;

type ApiFetchInit = Omit<RequestInit, "headers"> & {
  headers?: Record<string, string>;
  params?: Record<string, QueryValue>;
};

/**
 * Wraps `fetch` with the standard backend auth headers and URL builder.
 * Use this for mutations / one-off calls. Query hooks should rely on the
 * defaultQueryFn (which uses this under the hood).
 */
export const apiFetch = async (
  path: string,
  init: ApiFetchInit = {},
): Promise<Response> => {
  const { params, headers, ...rest } = init;
  const token = await acquireBackendToken();

  return fetch(apiUrl(path, params), {
    ...rest,
    headers: {
      Authorization: `Bearer ${token}`,
      "X-MS-CLIENT-PRINCIPAL": "something needs to be here",
      ...headers,
    },
  });
};
